import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiParameter,
    del,
    get,
    HasPagingParameters,
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import { BaseModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";

const customUrl = "/api/v1/customerPartNumbers/";

export interface CustomerPartModel {
    customerPartNumber: string;
    erpNumber: string;
    id: string;
}

export interface GetCustomerPartsApiParameter extends ApiParameter, HasPagingParameters {
    search?: string;
    searchMode?: string;
}

export interface CustomerPartCollectionModel extends BaseModel {
    customerParts: CustomerPartModel[] | null;
    pagination: PaginationModel | null;
}

export interface PostCustomerPartApiParameter extends ApiParameter {
    customerPart?: CustomerPartModel;
}

export interface GetCustomerPartApiParameter extends ApiParameter {
    erpNumber: string;
}

export interface DeleteCustomerPartApiParameter extends ApiParameter {
    erpNumber: string;
}

export async function getCustomerParts(parameter: GetCustomerPartsApiParameter) {
    const customerParts = await get<CustomerPartCollectionModel>(`${customUrl}`, parameter);
    return customerParts;
}

export async function getCustomerPart(parameter: string) {
    const customerPart = await get<CustomerPartModel>(`${customUrl}${parameter}`);
    return customerPart;
}

export async function postCustomerPart(parameter: PostCustomerPartApiParameter) {
    const customerPart = await post<CustomerPartModel>(`${customUrl}`, parameter.customerPart);
    return customerPart;
}

export async function deleteCustomerPart(parameter: string): Promise<ServiceResult<void>> {
    try {
        const noResponseExpected = await del(`${customUrl}${parameter}`);
        return {
            successful: true,
            result: noResponseExpected,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
